import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import createSagaMiddleware from 'redux-saga';
import rootReducer from '../reducers'; // rename to createRootReducer below
import rootSaga from '../sagas';
import { createBrowserHistory } from 'history';

const sagaMiddleware = createSagaMiddleware();
const middlewares = [thunk, sagaMiddleware];

export const history = createBrowserHistory();

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const asyncReducers = {};

const createRootReducer = (asyncReducers = {}) => {
  return rootReducer(asyncReducers); // updated reducer should be a function now
};

// Create the store
const store = createStore(
  createRootReducer(),
  composeEnhancers(applyMiddleware(...middlewares))
);

// Attach asyncReducers to store for dynamic injection
store.asyncReducers = asyncReducers;

// 🔁 Dynamic reducer injector
export const injectReducer = (key, reducer) => {
  if (store.asyncReducers[key]) return; // don't overwrite

  store.asyncReducers[key] = reducer;
  store.replaceReducer(createRootReducer(store.asyncReducers));
};

sagaMiddleware.run(rootSaga);

export default store;